import { Radio } from '@material-ui/core'
import styled from 'styled-components'

export const StyledRadio = styled(Radio)``

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
